<template>
  <transition name="fade">
    <div v-if="isInitialLoad" class="loading">
      <ProgressRing :progress="progress" :radius="100" :stroke="5" />
      <p>Loading...</p>
    </div>
  </transition>
  <router-view v-if="!isInitialLoad" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import ProgressRing from "@/components/ProgressRing.vue";

export default defineComponent({
  name: "App",
  components: { ProgressRing },
  computed: {
    ...mapGetters(["isInitialLoad"])
  },
  data() {
    return {
      progress: 0
    };
  },
  mounted() {
    setInterval(() => {
      this.progress += 1;
      if (this.progress === 200) this.progress = 0;
    }, 10);
  }
});
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.loading {
  background-color: white;
  z-index: 999999;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 3rem;

  p {
    padding-top: 5rem;
  }
}
</style>
